export function setupTopbarExperience(): () => void {
  const topbar = document.querySelector<HTMLElement>('[data-kaim-topbar]');
  if (!topbar) return () => undefined;

  const context = topbar.querySelector<HTMLElement>('[data-section-context]');
  const sectionHeadings = Array.from(document.querySelectorAll<HTMLElement>('.section .eyebrow'));
  let activeContext = context?.textContent || '';
  let pulseFrame = 0;

  const setContext = (next: string) => {
    if (!context || !next || next === activeContext) return;
    activeContext = next;
    context.textContent = next;
    const shell = context.parentElement;
    shell?.classList.remove('is-pulsing');
    if (pulseFrame) cancelAnimationFrame(pulseFrame);
    pulseFrame = requestAnimationFrame(() => shell?.classList.add('is-pulsing'));
  };

  const observer = context && sectionHeadings.length
    ? new IntersectionObserver((entries) => {
        let nearest: IntersectionObserverEntry | null = null;
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          if (!nearest || entry.boundingClientRect.top < nearest.boundingClientRect.top) nearest = entry;
        }
        const node = nearest?.target as HTMLElement | undefined;
        if (node) setContext(node.textContent?.trim() || '');
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 })
    : null;

  sectionHeadings.forEach((heading) => observer?.observe(heading));

  return () => {
    observer?.disconnect();
    if (pulseFrame) cancelAnimationFrame(pulseFrame);
  };
}
